module.exports = __webpack_public_path__ + "img/bg-mobile.3cd99a24.jpg";